var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#1169F4;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#40CD94;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#40CD94;stroke-width:4;stroke-miterlimit:10;}\n\t.st3{fill:#F2F2F2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "126.9,94.6 169.6,94.6 169.6,145.5 30.4,145.5 30.4,94.6 73.1,94.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.1,
    y: 56.8,
    className: "st1",
    width: 53.7,
    height: 46.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.9,56.8V42.6c0-11.1,9-20.1,20.1-20.1s20.1,9,20.1,20.1v14.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 126.9,
    y1: 80,
    x2: 106.5,
    y2: 80
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 68.2,
    y1: 128.8,
    x2: 53.6,
    y2: 114.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 68.2,
    y1: 114.1,
    x2: 53.6,
    y2: 128.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 94.3,
    y1: 128.8,
    x2: 79.7,
    y2: 114.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 94.3,
    y1: 114.1,
    x2: 79.7,
    y2: 128.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 120.3,
    y1: 128.8,
    x2: 105.7,
    y2: 114.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 120.3,
    y1: 114.1,
    x2: 105.7,
    y2: 128.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 146.4,
    y1: 128.8,
    x2: 131.8,
    y2: 114.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 146.4,
    y1: 114.1,
    x2: 131.8,
    y2: 128.8
  })))), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 100,
    cy: 173.1,
    rx: 72.2,
    ry: 4.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/Pin.a6af03a8837f9c1972ae4646b0cca0f8.svg";
export { ForwardRef as ReactComponent };